import { buildURL, handleResponse, requestMode } from '../classes/http-helper-const';
import { GetAccessToken } from '../functions/session-functions';
import HttpResponseOptions from '../interface/http-response-options';

export class FileUploadHttpService {
	private readonly uploadPath = 'upload';

	async upload(file: File, options?: HttpResponseOptions) {
		const url = buildURL('UploadStageFile', [this.uploadPath]);
		const formData = new FormData();
		formData.append('file', file, file.name);
		const response = await fetch(url, {
			method: 'POST',
			body: formData,
			mode: requestMode,
			credentials: 'include',
			headers: { Authorization: GetAccessToken() ?? '' },
		});
		await handleResponse(response, 'upload', 'UploadStageFile', options);
	}
}
